import { IM_MSG_SOURCEMAP } from '@/constant'
export default {
  methods: {
    /**
     * 判断最近一条消息是否左侧用户消息
     * @param lastImMessageDTO
     * @param idx
     * @returns {boolean}
     */
    isLastUserSendMsg(lastImMessageDTO, idx = lastImMessageDTO.length - 1) {
      const lastMsg = lastImMessageDTO[idx]
      // 无消息是返回false
      if (idx < 0 || !lastMsg) return false
      // 特殊系统代发场景 邀评则表示绝对停止计时
      if (lastMsg?.base?.content?.type === 'invite_comment') return false
      if (lastMsg?.base?.content?.type === 'invite_comment_new') return false
      // 排除 cmd消息,继续寻找上一条消息
      // 排除 系统代发消息,继续寻找上一条消息
      if (lastMsg?.base?.type === 'cmd' || lastMsg?.ext?.messageSendSource === IM_MSG_SOURCEMAP.system)
        return this.isLastUserSendMsg(lastImMessageDTO, idx - 1)
      return lastMsg.base.customerSource === 'To'
    },
    /**
     * 判断最近一条消息是在线客服消息
     * @param lastImMessageDTO
     * @param idx
     * @returns {boolean}
     */
    isLastSeatSendMsg(lastImMessageDTO, idx = lastImMessageDTO.length - 1) {
      const lastMsg = lastImMessageDTO[idx]
      // 无消息是返回false
      if (idx < 0 || !lastMsg) return false
      // 邀评则表示用户发的
      if (lastMsg?.base?.content?.type === 'invite_comment') return true
      if (lastMsg?.base?.content?.type === 'invite_comment_new') return true
      // 排除 cmd消息,继续寻找上一条消息
      // 排除 系统代发消息,继续寻找上一条消息
      if (lastMsg?.base?.type === 'cmd' || lastMsg?.ext?.messageSendSource === IM_MSG_SOURCEMAP.system)
        return this.isLastUserSendMsg(lastImMessageDTO, idx - 1)
      return lastMsg.base.customerSource === 'From'
    },
    /**
     * 倒数寻找最大的信标ID
     * @param lastImMessageDTO
     * @param idx
     * @returns {string|boolean|string|*}
     */
    findLastMaxOutSeqId(lastImMessageDTO, idx = lastImMessageDTO.length - 1) {
      const lastMsg = lastImMessageDTO[idx]
      // 无消息是返回false
      if (idx < 0 || !lastMsg) return '0'
      // 排除 cmd消息,继续寻找上一条消息
      // 排除 系统代发消息,继续寻找上一条消息
      if (!lastMsg.outSeqId) return this.findLastMaxOutSeqId(lastImMessageDTO, idx - 1)
      return lastMsg.outSeqId
    },
    // 是否aMsgList 消息id 大于 bMsgList
    greaterThanByOutSeqId(aMsgList, bMsgList) {
      let aMaxOutSeqId
      let bMaxOutSeqId
      if (aMsgList?.length) aMaxOutSeqId = aMsgList?.[aMsgList.length - 1]?.outSeqId || '0'
      if (bMsgList?.length) bMaxOutSeqId = bMsgList?.[bMsgList.length - 1]?.outSeqId || '0'
      return aMaxOutSeqId > bMaxOutSeqId
    }
  }
}
